export const pattern18Data = [
  {
    koreanChunks: ["우리는 (현재) 출시했다", "새로운 제품을", "이번 분기에"],
    englishChunks: ["We have launched", "a new product", "this quarter"],
    fullEnglish: "We have launched a new product this quarter.",
    additionalExplanation:
      "현재완료도 과거입니다. 그냥 이미 일어난 일인데 굳이 have를 써서 현재완료로 표현하는 이유는 완료된 과거의 얘기도 조금 다르게 얘기하고 싶을 때 원어민은 현재완료를 씁니다. 같은 일이 일어났어도 어떤 일은 그냥 과거의 한 일이 될 수도 있고 어떤 일은 과거라지만 최근에 일어난 일로 지금 현재와 연관성이 많은 과거도 있습니다. 이처럼 같은 완료된 일도 조금 다르게 말하고 싶을 때 원어민은 현재완료를 사용하는데요. 문법적으로 결과, 경험, 완료, 지속 이렇게 구분하기보단 원어민이 과거시제를 쓸 때는 이런 느낌을 말할 때 쓰고, 현재완료는 이런 얘기를 할 때 많이 쓰는 구나, 이렇게 접근해봅니다.",
  },
  {
    koreanChunks: ["우리는 (과거에)완료했다", "프로젝트를", "지난 금요일에"],
    englishChunks: ["We completed", "the project", "last Friday"],
    fullEnglish: "We completed the project last Friday.",
    additionalExplanation:
      "이 원어민은 단순히 지난 금요일에 프로젝트를 끝냈단 얘기를 하고 싶은 것으로 과거시제를 쓴 것을 볼 수 있습니다. 현재완료와의 차이를 느껴보면서 문장 훈련을 해보세요. 토익몬에서는 과거시제는 (과거에)~ 했다라고 시제를 붙여서 표현합니다.",
  },
  {
    koreanChunks: ["그녀는 (현재)일했다", "여기서", "5년 동안"],
    englishChunks: ["She has worked", "here", "for five years"],
    fullEnglish: "She has worked here for five years.",
    additionalExplanation:
      "같은 일한 사건도 원어민이 현재완료를 통해 어떻게 다르게 표현하는지 볼 수 있습니다. 단순히 과거에서 일했다라는 내용을 말하려면 과거시제를 썼겠지만 현재완료를 써서 같은 '일했다'를 현재와 연관된 일로 말할 수 있습니다. 토익몬에서는 현재 완료는 (현재)~ 했다로 해석합니다.",
  },
  {
    koreanChunks: ["그녀는 (과거에)보냈다", "그 청구서를", "어제"],
    englishChunks: ["She sent", "the invoice", "yesterday"],
    fullEnglish: "She sent the invoice yesterday.",
    additionalExplanation:
      "단순히 어제라는 과거타임에 청구서를 보냈다는 사실을 얘기하고 있습니다.",
  },
  {
    koreanChunks: ["나는 (현재)제출했다", "보고서를", "이미"],
    englishChunks: ["I have submitted", "the report", "already"],
    fullEnglish: "I have submitted the report already.",
    additionalExplanation:
      "화자가 왜 현재완료를 선택했을까에 집중해봅니다. 이 화자가 보고서를 과거 타임에 낸 사실을 말하려 했으면 현재완료를 쓰지 않았겠지만, 같은 완료된 사건도 현재완료를 써서 '난 이미 보고서를 냈다'라는 말을 하고 싶어서 현재완료를 쓴 걸 볼 수 있습니다. 시제는 딱딱 나눠지기가 어렵습니다. 이래도 답이 되고 저래도 답이 되는 경우가 많으니 의도 파악을 잘하는 게 더 유리합니다.",
  },
  {
    koreanChunks: ["회의는 (과거에)시작했다", "오전 10시에"],
    englishChunks: ["The meeting started", "at 10 a.m."],
    fullEnglish: "The meeting started at 10 a.m.",
    additionalExplanation:
      "이 문장은 단순 과거 시제를 사용하여 과거의 특정 시점(오전 10시)에 일어난 사건을 표현하고 있습니다. 이 사람은 단순히 과거에 일정을 말하려고 과거시제를 사용했습니다.",
  },
  {
    koreanChunks: ["그들은 (현재) 절대 놓친 적이 없다", "마감 기한을"],
    englishChunks: ["They have never missed", "a deadline"],
    fullEnglish: "They have never missed a deadline.",
    additionalExplanation:
      "안 일어난 것도 과거입니다. 과거에 어떤 일이 안 일어났다 = 이것도 완료된 일입니다. 그렇게 생각하면 쉽습니다. 즉 missed가 과거에 한 번도 안 일어났다는 것으로 화자는 놓친 적이 과거에 한 번도 없었다는 말을 하고 싶은 것입니다. 이 경우 과거에 특정 일은 단순히 얘기하는 게 아니기에 현재완료를 써서 같은 완료도 현재와 연관된 내용으로 이야기할 수 있습니다.",
  },
  {
    koreanChunks: ["나는 (과거에)일했다", "그 회사를 위해", "2019년에"],
    englishChunks: ["I worked", "for that company", "in 2019"],
    fullEnglish: "I worked for that company in 2019.",
    additionalExplanation:
      "이 문장은 단순 과거 시제를 사용하여 특정 과거 시점(2019년)에 일어난 사건을 표현하고 있습니다. 화자는 단순히 과거의 특정 시간에 그 회사에서 일했다는 사실을 전달하고 있으며, 현재와의 연관성을 강조하지 않기 때문에 과거 시제를 사용했습니다.",
  },
  {
    koreanChunks: ["그는 (현재)막 떠났다", "사무실을"],
    englishChunks: ["He has just left", "the office"],
    fullEnglish: "He has just left the office.",
    additionalExplanation:
      "이 사람은 떠난(left)일을 과거시점에 일어난 사건을 말하는 게 아니라 현재 즉, 이제 막 떠난 일을 이야기하고 싶어 현재완료를 사용한 것을 볼 수 있습니다. 현재와의 연관성을 강조하기 위해 현재완료를 선택해서 전달하고 있습니다.",
  },
  {
    koreanChunks: ["그는 (과거에)승인했다", "예산을", "마감 기한 전에"],
    englishChunks: ["He approved", "the budget", "before the deadline"],
    fullEnglish: "He approved the budget before the deadline.",
    additionalExplanation:
      "이 문장은 단순 과거 시제를 사용하여 과거에 일어난 사건을 표현하고 있습니다. 화자는 그가 마감 기한 전에 예산을 승인했다는 과거의 특정 사실을 전달하고 있으며, 현재와의 연관성보다는 과거에 완료된 행동 자체에 초점을 맞추고 있기 때문에 과거 시제를 사용했습니다.",
  },
  {
    koreanChunks: ["우리 팀은 (현재)향상시켰다", "생산성을", "상당히"],
    englishChunks: ["Our team has improved", "productivity", "significantly"],
    fullEnglish: "Our team has improved productivity significantly.",
    additionalExplanation:
      "화자가 (과거에) 향상시켰다 라고 말하면 어떤 차이가 있을까? 라고 생각해보면 현재완료의 쓰임을 이해할 수 있습니다. 단순 과거시제를 사용했다면 단지 과거의 사건으로만 표현되었을 것이지만, 현재완료를 사용함으로써 그 성과가 현재에도 관련이 있고 중요하다는 점을 강조하고 있습니다.",
  },
  {
    koreanChunks: ["그들은 (과거에)참석하지 않았다", "세미나에", "지난 주에"],
    englishChunks: ["They did not attend", "the seminar", "last week"],
    fullEnglish: "They didn't attend the seminar last week.",
    additionalExplanation:
      "이 문장은 단순 과거 시제를 사용하여 과거의 특정 시점(지난 주)에 일어나지 않은 사건을 표현하고 있습니다. 화자는 그들이 지난 주에 세미나에 참석하지 않았다는 과거의 사실을 전달하고 있으며, 현재와의 연관성보다는 과거에 일어난 일에 초점을 맞추고 있기 때문에 과거 시제를 사용했습니다.",
  },
  {
    koreanChunks: ["그 회사는 (현재)확장했다", "세 개의 새로운 시장으로"],
    englishChunks: ["The company has expanded", "into three new markets"],
    fullEnglish: "The company has expanded into three new markets.",
    additionalExplanation:
      "회사가 (과거에) 확장했다라고 말했을 때 차이가 어떨지 생각해보세요. 이 사람은 그런 과거 사건을 얘기하고 싶은 게 아니라 회사가 확장한 것은 과거에 일어났지만, 그 결과가 현재에도 지속되고 있음을 강조하기 위해 현재완료를 사용했습니다. 현재완료를 사용함으로써 그 확장이 현재에도 관련이 있고 중요하다는 점을 나타내고 있습니다.",
  },
  {
    koreanChunks: ["우리는 (과거에)가졌다 문제를", "시스템에", "어젯밤에"],
    englishChunks: ["We had an issue", "with the system", "last night"],
    fullEnglish: "We had an issue with the system last night.",
    additionalExplanation:
      "had가 나와서 과거완료라고 생각하지 않도록 주의합니다. have의 과거형입니다. 단순히 어젯밤에 시스템에 문제가 있었다는 내용을 전달합니다.",
  },
  {
    koreanChunks: ["나는 (현재) 방문했었다", "본사를", "도쿄에 있는", "이전에"],
    englishChunks: ["I have visited", "the headquarter", "in Tokyo", "before"],
    fullEnglish: "I have visited the headquarters in Tokyo before.",
    additionalExplanation:
      "본사를 방문했다라는 같은 과거 이야기지만 정확한 시점은 명시되지 않았습니다. 이 화자는 과거 특정 시점에 본사를 방문했단 얘기를 하고 싶은 게 아니라 과거에 본사를 방문했던 적이 있는 어떤 경험을 설명하려고 현재완료를 쓴 것을 볼 수 있습니다. 만약 '나는 (과거에) 방문했다'라고 표현했다면, 특정 과거 시점의 단일 사건으로만 인식되었을 것입니다.",
  },
  {
    koreanChunks: [
      "그녀는 (과거에)전화했다",
      "고객에게",
      "하지만 받지 못했다 응답을",
    ],
    englishChunks: ["She called", "the client", "but got no answer"],
    fullEnglish: "She called the client but got no answer.",
    additionalExplanation:
      "이 문장은 단순 과거 시제를 사용하여 과거에 일어난 두 가지 연속된 사건(전화를 걸었고, 응답을 받지 못했음)을 표현하고 있습니다. 화자는 과거의 특정 시점에 일어난 사실을 전달하고 있으며, 현재와의 연관성보다는 과거에 완료된 행동 자체에 초점을 맞추고 있기 때문에 과거 시제를 사용했습니다.",
  },

  {
    koreanChunks: ["배송이 (과거에)도착했다", "정시에"],
    englishChunks: ["The shipment arrived", "on time"],
    fullEnglish: "The shipment arrived on time.",
    additionalExplanation:
      "이 문장은 단순 과거 시제를 사용하여 과거에 일어난 사건을 표현하고 있습니다. 화자는 배송이 정시에 도착했다는 과거의 특정 사실을 전달하고 있으며, 현재와의 연관성보다는 과거에 완료된 행동 자체에 초점을 맞추고 있기 때문에 과거 시제를 사용했습니다.",
  },
  {
    koreanChunks: ["나는 (과거에)만났다", "CEO를", "컨퍼런스 동안"],
    englishChunks: ["I met", "the CEO", "during the conference"],
    fullEnglish: "I met the CEO during the conference.",
    additionalExplanation:
      "이 문장은 단순 과거 시제를 사용하여 과거에 일어난 사건을 표현하고 있습니다. 화자는 컨퍼런스 동안 CEO를 만났다는 과거의 특정 사실을 전달하고 있으며, 현재와의 연관성보다는 과거에 완료된 행동 자체에 초점을 맞추고 있기 때문에 과거 시제를 사용했습니다.",
  },
  {
    koreanChunks: [
      "우리는 (현재)받았다",
      "귀하의 문의를",
      "그리고 (미래)응답할 것입니다",
      "곧",
    ],
    englishChunks: [
      "We have received",
      "your inquiry",
      "and will respond",
      "shortly",
    ],
    fullEnglish: "We have received your inquiry and will respond shortly.",
    additionalExplanation:
      "이 문장은 현재완료 시제를 사용하여 과거에 일어났지만 현재와 관련이 있는 사건(문의를 받은 것)을 표현하고 있습니다. '받았다'는 과거에 일어났지만 지금 이 화자는 단순히 과거에 받았다는 이야기를 하는 것이 아니라 고객에게 받았고 현재 그것에 대해 응답하겠다는 내용을 말하기 위해 현재와 연관된 과거로 현재완료를 쓴 것을 볼 수 있습니다. 과거시제가 못 온다는 것이 아니라, 화자가 하고 싶은 말이 달라서 현재완료가 오는 겁니다. 시제는 법칙처럼 구분해서 공부할 경우 더 어렵습니다. 이 사람이 지금 하려는 말이 뭔가에 초점을 맞춰야 합니다.",
  },
  {
    koreanChunks: ["그녀는 (현재) 매우 도움이 되었다", "프로젝트 전반에 걸쳐"],
    englishChunks: ["She has been very helpful", "throughout the project"],
    fullEnglish: "She has been very helpful throughout the project.",
    additionalExplanation:
      "도움이 됐다는 완료된 사건도 과거 특정 시점에 도움됐다는 게 아닌 이 화자는 그녀가 현재 너무 큰 도움이 되었단 내용을 말하기 위해 현재완료를 쓴 것을 볼 수 있습니다. 말 그대로 현재 + 완료입니다. 현재 완료된 일을 말하고 싶을 때 쓴다고 봅니다.",
  },
  {
    koreanChunks: ["우리는 (현재) 충족했다", "모든 요구 사항을", "인증을 위한"],
    englishChunks: ["We have met", "all the requirements for certification"],
    fullEnglish: "We have met all the requirements for certification.",
    additionalExplanation:
      "이 화자가 지금 과거에 충족한 사실을 전달하려는 것이 아니라 현재 충족된 완료된 내용을 이야기하려는 것을 알 수 있습니다. ",
  },
  {
    koreanChunks: ["매출이 (현재) 증가했다 꾸준히", "작년 이후로"],
    englishChunks: ["Sales have increased steadily", "since last year"],
    fullEnglish: "Sales have increased steadily since last year.",
    additionalExplanation:
      " '증가했다'라는 같은 완료 상태이지만 단순 과거에 완료한 것을 말하려는 게 아니라 화자는 작년 이후로 꾸준히 증가했다는 말을 하기 위해 현재완료를 사용했습니다. 화자가 어떤 것을 더 표현하고 싶어하는지를 잘 봐야 합니다.",
  },
  {
    koreanChunks: ["그는 (현재) 일했다", "판매와 마케팅 모두에서"],
    englishChunks: ["He has worked", "in both sales and marketing"],
    fullEnglish: "He has worked in both sales and marketing.",
    additionalExplanation:
      "이 화자는 has 하나를 써서 일했다는 과거 사건이 현재도 지속되고 있음을 알 수 있게 합니다.",
  },
  {
    koreanChunks: ["나는 (과거) 들어본 적이 없다", "그 공급업체에 대해"],
    englishChunks: ["I have never heard", "of that supplier"],
    fullEnglish: "I have never heard of that supplier.",
    additionalExplanation:
      "안 들어본 것도 과거의 일입니다. 과거 특정 시점에 안 들었다라는 말을 전달하려는 게 아니라 화자는 과거 전체 그리고 지금까지 안 들었다라는 경험을 이야기하고자 have를 붙인 걸 볼 수 있습니다. ",
  },
  {
    koreanChunks: ["우리는 (현재) 확정하지 않았다", "예산을", "아직"],
    englishChunks: ["We have not finalized", "the budget", "yet"],
    fullEnglish: "We have not finalized the budget yet.",
    additionalExplanation:
      "화자는 과거에 딱 예산확정이 안됐다라는 사실을 얘기하려는 게 아니라, '확정 안됐다'라는 같은 완료의 일도 have와 yet을 붙여서 현재와 연관지어 설명하려고 하는 걸 알 수 있습니다.",
  },
  {
    koreanChunks: ["고객이 (현재) 요청했다", "수정을", "계약서에 대한"],
    englishChunks: [
      "The client has requested",
      "a revision",
      "to the contract",
    ],
    fullEnglish: "The client has requested a revision to the contract.",
    additionalExplanation:
      "같은 '요청했다'도 has를 붙이니 그것이 단순히 과거에 요청했다라는 것이 아닌 현재까지 요청했던 느낌을 알 수 있습니다. ",
  },
  {
    koreanChunks: ["그녀는 (현재) 방문했다", "우리 지점을", "여러 번"],
    englishChunks: ["She has visited", "our branch", "several times"],
    fullEnglish: "She has visited our branch several times.",
    additionalExplanation:
      "화자는 무슨 말을 하고 싶었던 걸까요? 과거 특정 시점에 방문했다는 게 아닌 과거 전체에 방문했던, 그것도 여러 번 방문했던 일을 말하려고 has를 붙였습니다.",
  },
  {
    koreanChunks: ["그들은 (현재) 열었다", "새 사무실을", "싱가포르에"],
    englishChunks: ["They have opened", "a new office", "in Singapore"],
    fullEnglish: "They have opened a new office in Singapore.",
    additionalExplanation:
      "그들은 (과거에) 열었다 vs 그들은 (현재)열었다 -> 이차이가 인식되면 현재완료는 성공입니다",
  },
  {
    koreanChunks: ["우리는 (과거에) 실시했다", "설문조사를", "4월에"],
    englishChunks: ["We conducted", "a survey", "in April"],
    fullEnglish: "We conducted a survey in April.",
    additionalExplanation:
      "이 화자는 4월에 설문조사했던 사실을 단순히 전달하려고 했음을 알 수 있습니다. ",
  },
  {
    koreanChunks: ["사무실이 (과거에) 문을 닫았다", "일찍", "유지보수 때문에"],
    englishChunks: ["The office closed", "early", "due to maintenance"],
    fullEnglish: "The office closed early due to maintenance.",
    additionalExplanation:
      "이사람이 맗하려고 했던건 과거에 유지보수로 문을 일찍 닫았다는 내용을 전달하려고 하는걸 알 수 있습니다.",
  },
  {
    koreanChunks: [
      "우리 회사는 (현재)수출한다",
      "상품들을",
      "20개 이상의 국가로",
    ],
    englishChunks: ["Our company exports", "goods", "to over 20 countries"],
    fullEnglish: "Our company exports goods to over 20 countries.",
    additionalExplanation:
      "토익몬에서는 현재시제를 (현재)~한다 라고 해석하는데요, 현재 ~ 한다라는 말을 쓰는 경우가 무엇이 있을까 생각하며 훈련해볼게요, 여기서는 지금 현재 우리가 수출한다는 일반적 사실을 전달하고 있습니다. 단순히 현재 그러고 있다 라는 말을 화자가 하고 싶어 하는 걸 알 수 있습니다.",
  },
  {
    koreanChunks: ["그녀는 (현재) 처리한다", "고객 불만을", "오후에"],
    englishChunks: ["She handles", "customer complaints", "in the afternoon"],
    fullEnglish: "She handles customer complaints in the afternoon.",
    additionalExplanation:
      "이 화자는 오후에 고객불만을 처리하는 중이 아니라 처리한다. 오후에는 고객불만을 처리한다는 내용으로 단순히 어떤 시간에 어떤 일을 한다는 내용을 전달합니다. 이건 과거도 미래도 아닌 그저 현재 매일 그 시간에 일어나는 일로 원어민은 이런 반복되는 업무 일을 표현할 때 현재 시제를 사용합니다 ",
  },
  {
    koreanChunks: ["회의는 (현재) 시작한다", "오후 2시에"],
    englishChunks: ["The meeting starts", "at 2 p.m."],
    fullEnglish: "The meeting starts at 2 p.m.",
    additionalExplanation:
      "원어민은 그저 정해진 일정을 말할때는 현재시제를 사용합니다.",
  },
  {
    koreanChunks: [
      "우리는 보통 (현재) 제공합니다.",
      "할인을",
      "대량 구매자들에게",
    ],
    englishChunks: ["We usually offer", "discounts", "to bulk buyers"],
    fullEnglish: "We usually offer discounts to bulk buyers.",
    additionalExplanation:
      "원어민은 늘 일어나는 일을 표현할 때 현재시제를 씁니다. 내가 이런 말을 할 때, 나는 어떤 시제를 그럼 고를까? 생각해보면서 훈련해보세요",
  },
  {
    koreanChunks: ["그는 (현재) 운전한다", "직장까지", "매일"],
    englishChunks: ["He drives", "to work", "every day"],
    fullEnglish: "He drives to work every day.",
    additionalExplanation:
      "이 문장은 매일 반복되는 행동을 표현하고 있습니다. 원어민들은 이런 일상적인 습관이나 반복되는 행동을 표현할 때 현재시제를 사용합니다. '매일'이라는 표현이 현재시제와 함께 사용되어 규칙적으로 일어나는 행동임을 강조합니다.",
  },
  {
    koreanChunks: ["사무실은 (현재) 문을 닫는다", "오후 6시에"],
    englishChunks: ["The office closes", "at 6 p.m."],
    fullEnglish: "The office closes at 6 p.m.",
    additionalExplanation:
      "이 문장은 사무실이 매일 오후 6시에 문을 닫는다는 일상적인 일정이나 규칙을 표현하고 있습니다. 원어민들은 이런 정해진 일정이나 시간표를 말할 때 현재시제를 사용합니다. 미래의 일이 아니라 현재의 규칙적인 사실로 표현하는 것이 자연스럽습니다.",
  },
  {
    koreanChunks: ["그녀는 (현재) 말한다", "세 가지 언어를", "유창하게"],
    englishChunks: ["She speaks", "three languages", "fluently"],
    fullEnglish: "She speaks three languages fluently.",
    additionalExplanation:
      "이 문장은 그녀가 세 가지 언어를 유창하게 구사할 수 있는 능력을 표현하고 있습니다. 원어민들은 이런 현재의 능력이나 상태를 표현할 때 현재시제를 사용합니다. 이것은 일시적인 행동이 아니라 지속적인 능력을 나타내므로 현재시제가 적합합니다.",
  },
  {
    koreanChunks: ["물은 (현재) 끓는다", "100°C에서"],
    englishChunks: ["Water boils", "at 100°C"],
    fullEnglish: "Water boils at 100°C.",
    additionalExplanation:
      "이 문장은 물이 100°C에서 끓는다는 과학적 사실을 표현하고 있습니다. 원어민들은 이런 보편적인 진리나 자연 법칙을 설명할 때 현재시제를 사용합니다. 이는 과거에도 그랬고 미래에도 변하지 않는 사실이기 때문에 현재시제로 표현하는 것이 가장 적합합니다.",
  },
  {
    koreanChunks: ["보고서는 (현재) 보여준다", "감소를", "수익의"],
    englishChunks: ["The report shows", "a decline", "in revenue"],
    fullEnglish: "The report shows a decline in revenue.",
    additionalExplanation:
      "이 문장은 보고서가 현재 보여주고 있는 내용에 대해 설명하고 있습니다. 원어민들은 현재 존재하는 문서나 자료가 담고 있는 내용을 설명할 때 현재시제를 사용합니다. 보고서의 내용은 지금 현재 존재하는 사실이므로 현재시제로 표현하는 것이 자연스럽습니다.",
  },
  {
    koreanChunks: ["이 앱은 (현재) 추적한다", "당신의 일일 걸음 수를"],
    englishChunks: ["This app tracks", "your daily steps"],
    fullEnglish: "This app tracks your daily steps.",
    additionalExplanation:
      "이 문장은 앱의 현재 기능이나 목적을 설명하고 있습니다. 원어민들은 제품이나 서비스의 기능을 설명할 때 현재시제를 사용합니다. 이는 앱이 지속적으로 수행하는 기능이므로 현재시제로 표현하는 것이 자연스럽습니다.",
  },
  {
    koreanChunks: ["CEO는 (현재) 믿는다", "열린 소통을"],
    englishChunks: ["The CEO believes", "in open communication"],
    fullEnglish: "The CEO believes in open communication.",
    additionalExplanation:
      "이 문장은 CEO의 현재 신념이나 가치관을 표현하고 있습니다. 원어민들은 현재 가지고 있는 생각, 신념, 의견 등을 표현할 때 현재시제를 사용합니다. 이는 일시적인 행동이 아니라 지속적인 마음의 상태나 태도를 나타내므로 현재시제가 적합합니다.",
  },
  {
    koreanChunks: ["이 브로셔는 (현재) 포함한다", "모든 관련 정보를"],
    englishChunks: ["This brochure includes", "all relevant information"],
    fullEnglish: "This brochure includes all relevant information.",
    additionalExplanation:
      "이 문장은 브로셔가 현재 담고 있는 내용에 대해 설명하고 있습니다. 원어민들은 현재 존재하는 문서나 자료가 포함하고 있는 내용을 설명할 때 현재시제를 사용합니다. 브로셔의 내용은 지금 현재 존재하는 사실이므로 현재시제로 표현하는 것이 자연스럽습니다.",
  },
  {
    koreanChunks: ["그녀는 (현재) 느낀다", "자신감을", "발표에 대해"],
    englishChunks: ["She feels", "confident", "about the presentation"],
    fullEnglish: "She feels confident about the presentation.",
    additionalExplanation:
      "이 문장은 그녀가 발표에 대해 현재 느끼는 감정이나 상태를 표현하고 있습니다. 원어민들은 현재의 감정이나 심리 상태를 표현할 때 현재시제를 사용합니다. 이는 현재 지속되는 감정 상태를 나타내므로 현재시제가 적합합니다.",
  },
  {
    koreanChunks: [
      "우리 웹사이트는 (현재) 제공한다",
      "무료 배송을",
      "모든 주문에",
    ],
    englishChunks: ["Our website offers", "free shipping", "on all orders"],
    fullEnglish: "Our website offers free shipping on all orders.",
    additionalExplanation:
      "이 문장은 웹사이트가 현재 제공하는 서비스나 정책을 설명하고 있습니다. 원어민들은 현재 시행 중인 정책이나 서비스를 설명할 때 현재시제를 사용합니다. 이는 지속적으로 제공되는 서비스이므로 현재시제로 표현하는 것이 자연스럽습니다.",
  },
  {
    koreanChunks: ["그는 (현재) 가르친다", "마케팅을", "대학에서"],
    englishChunks: ["He teaches", "marketing", "at the university"],
    fullEnglish: "He teaches marketing at the university.",
    additionalExplanation:
      "이 문장은 그가 대학에서 마케팅을 가르치는 현재의 직업이나 정기적인 활동을 설명하고 있습니다. 원어민들은 현재 하고 있는 직업이나 정기적으로 반복되는 활동을 설명할 때 현재시제를 사용합니다. 이는 일시적인 행동이 아니라 지속적으로 수행하는 활동이므로 현재시제가 적합합니다.",
  },
  {
    koreanChunks: ["우리는 (현재) 검토 중이다", "제안서를", "현재"],
    englishChunks: ["We are reviewing", "the proposal", "at the moment"],
    fullEnglish: "We are reviewing the proposal at the moment.",
    additionalExplanation:
      "원어민들은 지금 이 순간 진행 중인 활동을 설명할 때 현재진행형을 사용합니다. 'at the moment'는 '현재', '지금'이라는 의미로 이는 일시적으로 진행 중인 행동을 강조하는 현재진행시제의 전형적인 사용 예입니다.",
  },
  {
    koreanChunks: ["그녀는 (현재) 참석 중이다", "세미나에", "이번 주에"],
    englishChunks: ["She is attending", "a seminar", "this week"],
    fullEnglish: "She is attending a seminar this week.",
    additionalExplanation:
      "이 문장은 현재 참석 중인데 이번 주에 라는 말을 통해 아, 참석 중인 행동이 일시적인 활동임을 알 수 있습니다. 어떤 현재 일어나는 것 중 일시적 활동을 얘기하고 싶을 때 원어민이 현재진행을 쓰기도 하는구나, 라고 생각하면 됩니다. 그들이 그들의 언어를 이렇게 쓰는구나, 인식하는 것이 중요합니다. 정해진 규칙은 이건데 왜 이건 이렇게 얘기하지? 하며 한국 해설에 맞춰서 왜 영어가 이러지? 생각하면 너무 힘들어집니다. 그대로 받아들여 보세요.",
  },
  {
    koreanChunks: ["나는 (현재) 기다리는 중이다", "그의 답장을", "지금"],
    englishChunks: ["I am waiting", "for his reply", "right now"],
    fullEnglish: "I am waiting for his reply right now.",
    additionalExplanation:
      "이 문장은 현재 진행 중인 행동을 표현하고 있습니다. '지금(right now)'이라는 시간 표현과 함께 사용되어 현재 이 순간에 일어나고 있는 일시적인 행동임을 강조합니다. 원어민들은 이처럼 특정 시점에 진행 중인 행동을 설명할 때 현재진행형을 사용합니다. 이는 일반적인 사실이나 습관이 아닌, 현재 순간에 일어나고 있는 구체적인 활동을 나타냅니다.",
  },
  {
    koreanChunks: [
      "그녀는 (현재) 처리하는 중이다",
      "고객 피드백을",
      "이번 주에",
    ],
    englishChunks: ["She is handling", "customer feedback", "this week"],
    fullEnglish: "She is handling customer feedback this week.",
    additionalExplanation:
      "이 문장은 현재 진행 중인 일시적인 활동을 표현하고 있습니다. '이번 주에(this week)'라는 시간 표현은 이 활동이 제한된 기간 동안 일어나고 있음을 나타냅니다. 원어민들은 특정 기간 동안 진행되는 일시적인 활동을 설명할 때 현재진행형을 사용합니다. 이는 일상적인 업무가 아닌, 이번 주에 특별히 맡은 임시 업무를 나타내는 데 적합한 시제입니다.",
  },
  {
    koreanChunks: ["우리는 (현재) 보는 중이다", "판매 증가를", "이번 달에"],
    englishChunks: ["We are seeing", "an increase in sales", "this month"],
    fullEnglish: "We are seeing an increase in sales this month.",
    additionalExplanation:
      "이 문장은 현재 진행 중인 상황을 설명하고 있습니다. '이번 달에(this month)'라는 시간 표현은 이 상황이 제한된 기간 동안 일어나고 있음을 나타냅니다. 원어민들은 현재 진행 중인 일시적인 상황이나 변화를 설명할 때 현재진행형을 사용합니다. 이는 일반적인 사실이 아닌, 특정 기간 동안 관찰되는 변화나 추세를 표현하는 데 적합한 시제입니다.",
  },
  {
    koreanChunks: [
      "우리는 (현재) 계획 중이다",
      "출시하기 위해",
      "모바일 버전을",
      "곧",
    ],
    englishChunks: [
      "We are planning",
      "to launch ",
      "a mobile version",
      "soon",
    ],
    fullEnglish: "We are planning to launch a mobile version soon.",
    additionalExplanation:
      "화자가 가까운 미래에 일어날 계획된 활동을 현재진행형으로 표현하고 있습니다. '곧(soon)'이라는 시간 표현과 함께 사용되어 현재 진행 중인 계획이 가까운 미래에 실현될 것임을 나타냅니다. 원어민들은 이미 결정되었고 실행 예정인 가까운 미래의 계획을 표현할 때 종종 현재진행형을 사용합니다. 이는 단순한 의도보다 더 구체적이고 확실한 계획을 나타내는 데 효과적인 표현입니다.",
  },
  {
    koreanChunks: ["팀은 (현재) 만나는 중이다", "고객과", "다음 월요일에"],
    englishChunks: ["The team is meeting", "with the client", "next Monday"],
    fullEnglish: "The team is meeting with the client next Monday.",
    additionalExplanation:
      "이 원어민이 왜 미래시제를 안 쓰고 현재진행시제를 썼을까? 생각해봅시다. 미래시제보다 현재진행을 사용하면 좀 더 확실하고 구체적인 계획을 강조할 수 있기 때문입니다. 현재진행시제를 쓰면서 미래 시점(다음 주 월요일)을 쓰니 그 일이 곧 일어나는 느낌, 그리고 실행이 예정된 것처럼 보입니다.",
  },
  {
    koreanChunks: [
      "우리 회사는 (현재) 참가하는 중이다",
      "무역 박람회에",
      "이번 금요일에",
    ],
    englishChunks: [
      "Our company is participating",
      "in the trade show",
      "this Friday",
    ],
    fullEnglish: "Our company is participating in the trade show this Friday.",
    additionalExplanation:
      "이 화자는 현재진행시제와 '이번 금요일에(this Friday)'라는 구체적인 시간 표현과 함께 사용해서 이미 결정되고 확정된 일정임을 강조합니다. 원어민들은 이처럼 가까운 미래에 확실히 일어날 예정된 일을 표현할 때 종종 현재진행형을 사용합니다. 이는 단순한 미래 시제보다 더 확실하고 구체적인 계획을 나타내며, 이미 모든 준비가 진행 중임을 함축합니다.",
  },
  {
    koreanChunks: ["우리는 (미래에) 출시할 것이다", "새 제품을", "다음 달에"],
    englishChunks: ["We will launch", "the new product", "next month"],
    fullEnglish: "We will launch the new product next month.",
    additionalExplanation:
      "좀 더 공식적인 발표나 미래 계획을 말할 때는 원어민들은 미래시제를 사용합니다.",
  },
  {
    koreanChunks: [
      "마케팅 팀이 (미래에)발표할 예정이다",
      "캠페인 전략을",
      "다음 주에",
    ],
    englishChunks: [
      "The marketing team will present",
      "the campaign strategy",
      "next week",
    ],
    fullEnglish:
      "The marketing team will present the campaign strategy next week.",
    additionalExplanation:
      "이 문장은 미래에 일어날 계획된 행동을 표현하기 위해 미래시제(will)를 사용하고 있습니다. '다음 주에(next week)'라는 시간 표현과 함께 사용되어 앞으로 일어날 공식적인 발표나 계획을 나타냅니다. 원어민들은 이처럼 공식적인 발표나 확정된 미래 계획을 언급할 때 종종 'will'을 사용한 미래시제를 선택합니다. 이는 현재진행형으로 표현하는 임박한 계획보다 조금 더 공식적이고 객관적인 느낌을 줍니다.",
  },
  {
    koreanChunks: ["보고서가 (미래에) 준비될 것이다", "오늘 업무 종료까지"],
    englishChunks: ["The report will be ready", "by the end of the day"],
    fullEnglish: "The report will be ready by the end of the day.",
    additionalExplanation:
      "이 문장은 미래에 완료될 예정인 상황을 표현하기 위해 미래시제(will)를 사용하고 있습니다. '오늘 업무 종료까지(by the end of the day)'라는 시간 표현과 함께 사용되어 특정 시점까지 완료될 것이라는 확신이나 약속을 나타냅니다. 원어민들은 이처럼 특정 시간까지 완료될 예정인 일을 언급할 때 'will'을 사용한 미래시제를 선택합니다. 이는 업무 환경에서 자주 사용되는 표현으로, 마감 시간이나 완료 예정 시간을 명확하게 전달합니다.",
  },
  {
    koreanChunks: ["우리 사무실은 (미래에) 닫혀 있을 것이다", "휴일 동안"],
    englishChunks: ["Our office will be closed", "during the holiday"],
    fullEnglish: "Our office will be closed during the holiday.",
    additionalExplanation:
      "이 문장은 미래에 발생할 상황을 표현하기 위해 미래시제(will)를 사용하고 있습니다. '휴일 동안(during the holiday)'이라는 시간 표현과 함께 사용되어 특정 기간 동안의 상태를 나타냅니다. 원어민들은 이처럼 미래의 확정된 계획이나 공지사항을 전달할 때 'will'을 사용한 미래시제를 선택합니다. 이는 공식적인 안내나 공지에서 자주 볼 수 있는 표현 방식입니다.",
  },
  {
    koreanChunks: [
      "그녀는 (미래에) 답장할 것이다",
      "당신의 이메일에",
      "나중에 오늘",
    ],
    englishChunks: ["She will respond", "to your email", "later today"],
    fullEnglish: "She will respond to your email later today.",
    additionalExplanation:
      "이 문장은 가까운 미래에 일어날 행동을 표현하기 위해 미래시제(will)를 사용하고 있습니다. '오늘 나중에(later today)'라는 시간 표현과 함께 사용되어 당일 내에 일어날 예정된 행동을 나타냅니다. 원어민들은 이처럼 확실한 미래의 약속이나 의도를 표현할 때 'will'을 사용합니다. 이는 업무 환경에서 자주 사용되는 표현으로, 상대방에게 확신을 주는 방식으로 커뮤니케이션합니다.",
  },
  {
    koreanChunks: ["우리는 (미래에) 참석할 것이다", "회의에", "내일 아침에"],
    englishChunks: ["We will attend", "the meeting", "tomorrow morning"],
    fullEnglish: "We will attend the meeting tomorrow morning.",
    additionalExplanation:
      "이 문장은 미래에 일어날 행동을 표현하기 위해 미래시제(will)를 사용하고 있습니다. '내일 아침에(tomorrow morning)'라는 구체적인 시간 표현과 함께 사용되어 가까운 미래에 예정된 일정을 나타냅니다. 원어민들은 이처럼 확정된 미래 계획을 언급할 때 'will'을 사용한 미래시제를 선택합니다. 이는 공식적인 약속이나 일정을 전달할 때 적합한 표현 방식입니다.",
  },
  {
    koreanChunks: ["나는 (현재)일하는 중이었다.", "보고서 작업에", "아침 내내"],
    englishChunks: ["I have been working", "on the report", "all morning"],
    fullEnglish: "I have been working on the report all morning.",
    additionalExplanation:
      "토익몬에서는 현재완료진행 해석을 (현재)~중이었다라고 해석하는데요. 지금 이 화자는 자신이 과거에 일하는 중이었다는 것을 이야기하고 싶은 게 아니라 과거에도 일하는 중이었고 현재도 일하는 중이었음을 언급하고자 have been working이란 표현을 썼습니다. 단순히 내가 과거에 일하는 중이었어가 아니라 내가 지금 열심히 일하고 있어를 표현하려고 현재완료진행을 쓴 것입니다.",
  },
  {
    koreanChunks: ["그녀는 (현재)관리하는 중이었다", "프로젝트를", "1월부터"],
    englishChunks: ["She has been managing", "the project", "since January"],
    fullEnglish: "She has been managing the project since January.",
    additionalExplanation:
      "화자는 단순히 과거에 자신이 프로젝트를 관리하는 중이었음을 이야기하기보다는 현재완료진행시제와 '1월부터(since January)'라는 시간 표현을 함께 사용하여 같은 '관리중이다'도 1월부터 쭉 현재까지 관리중이다라고 말하고 있습니다.",
  },
  {
    koreanChunks: [
      "그들은 (현재)사용하는 중이었다",
      "새 소프트웨어를",
      "2주 동안",
    ],
    englishChunks: [
      "They have been using",
      "the new software",
      "for two weeks",
    ],
    fullEnglish: "They have been using the new software for two weeks.",
    additionalExplanation:
      "(현재 또는 과거에) 사용 중이었다 vs (현재) 2주째 사용 중이었다 이렇게 생각하면 쉽습니다",
  },
  {
    koreanChunks: ["우리는 (현재)논의하는 중이었다", "계약 수정사항을"],
    englishChunks: ["We have been discussing", "the contract revisions"],
    fullEnglish: "We have been discussing the contract revisions.",
    additionalExplanation:
      "그냥 논의중이었다가 아니라 최근까지, 즉 현재까지도 계속 논의중임을 말하고 싶을 때는 원어민들은 현재완료진행시제를 사용합니다",
  },
  {
    koreanChunks: ["그는 (현재)참석하는 중이었다", "교육 세션에", "정기적으로"],
    englishChunks: ["He has been attending", "training sessions", "regularly"],
    fullEnglish: "He has been attending training sessions regularly.",
    additionalExplanation:
      "이 화자는 반복적으로(정기적으로) 그리고 현재까지도 참석 중이었음을 이야기하고 싶어서 현재완료진행시제를 택했습니다",
  },
  {
    koreanChunks: [
      "나는 (현재)전화하는 중이었다",
      "공급업체에게",
      "하지만 응답이 없다",
    ],
    englishChunks: [
      "I have been calling",
      "the supplier",
      "but there's no response",
    ],
    fullEnglish: "I have been calling the supplier, but there's no response.",
    additionalExplanation:
      "화자는 공급업체에 여러 번 전화를 시도했고 지금까지도 계속 시도하고 있지만 응답이 없는 상황을 설명하고 있습니다. 단순히 '전화했다'가 아니라 '전화하는 중이었다'라고 표현함으로써 지속적인 노력과 현재까지 이어지는 상황을 강조합니다.",
  },
  {
    koreanChunks: [
      "그들은 (현재)준비하는 중이었다",
      "감사를 위해",
      "하루 종일",
    ],
    englishChunks: ["They have been preparing", "for the audit", "all day"],
    fullEnglish: "They have been preparing for the audit all day.",
    additionalExplanation:
      "현재완료진행과'하루 종일(all day)'이라는 시간 표현과 함께 사용되어 지속적인 준비 과정을 강조합니다. 단순히 '준비했다'가 아니라 '준비하는 중이었다'라고 표현함으로써 현재까지 이어지는 지속적인 노력을 나타냅니다. ",
  },
  {
    koreanChunks: ["그녀는 (현재)처리하는 중이었다", "모든 고객 불만사항을"],
    englishChunks: ["She has been handling", "all customer complaints"],
    fullEnglish: "She has been handling all customer complaints.",
    additionalExplanation:
      "화자는 그녀가 과거부터 지금까지 계속해서 고객 불만사항을 처리해왔음을 말하려고 현재완료진행을 사용했습니다. 단순히 '처리했다'가 아니라 '처리하는 중이었다'라고 표현함으로써 지속적인 책임과 현재까지 이어지는 업무를 강조합니다.",
  },
  {
    koreanChunks: ["그들은 (현재)경험하는 중이었다", "기술적 문제들을"],
    englishChunks: ["They have been experiencing", "technical issues"],
    fullEnglish: "They have been experiencing technical issues.",
    additionalExplanation:
      " 단순히 '경험했다'가 아니라 '경험하는 중이었다'라고 표현함으로써 기술적 문제가 일시적인 것이 아니라 지속적으로 발생하고 있음을 강조합니다. ",
  },
  {
    koreanChunks: ["우리 회사는 (현재)받는 중이었다", "많은 문의를", "최근에"],
    englishChunks: [
      "Our company has been receiving",
      "many inquiries",
      "lately",
    ],
    fullEnglish: "Our company has been receiving many inquiries lately.",
    additionalExplanation:
      " 단순히 '많은 문의를 받았다'가 아니라 '받는 중이었다'라고 표현함으로써 문의가 계속해서 들어오고 있는 지속적인 상황임을 강조합니다. ",
  },
  {
    koreanChunks: ["그는 (현재)협상하는 중이었다", "고객과", "한 주 내내"],
    englishChunks: ["He has been negotiating", "with the client", "all week"],
    fullEnglish: "He has been negotiating with the client all week.",
    additionalExplanation:
      "'한 주 내내(all week)'라는 시간 표현과 함께 사용되어 지속적인 협상 과정을 강조합니다. 단순히 '협상했다'가 아니라 '협상하는 중이었다'라고 표현함으로써 현재까지 이어지는 지속적인 노력을 나타냅니다. 시제 표현을 암기하라는 것이 아닙니다. 이런 시제 표현과 현재완료진행이 만나면 어떤 느낌이고 원어민들이 어떤 내용을 의도적으로 말하고 싶을 때 현재완료진행을 쓰는지 봅니다.",
  },
  {
    koreanChunks: [
      "우리는 (과거에)끝냈다.",
      "프로젝트를",
      "고객이 (과거에)도착하기 전에",
    ],
    englishChunks: [
      "We had finished",
      "the project",
      "before the client arrived",
    ],
    fullEnglish: "We had finished the project before the client arrived.",
    additionalExplanation:
      "토익몬에서는 과거완료, 과거시제 해석을 동일하게 합니다. 다만 이 화자가 과거완료를 사용한 이유는 고객 도착 전에 끝냈다는 내용을 강조하고 싶어서 그런 것 뿐입니다. ",
  },
  {
    koreanChunks: [
      "그녀는 (과거에)이미 보냈다",
      "이메일을",
      "내가 그녀에게 (과거에)물었을 때",
    ],
    englishChunks: ["She had already sent", "the email", "when I asked her"],
    fullEnglish: "She had already sent the email when I asked her.",
    additionalExplanation:
      "이 화자가 하고 싶었던 말은 자신이 그녀에게 물어봤을 때 이미 이메일을 보냈더라, 라는 내용을 강조하고 싶어서 had를 붙인 것입니다.",
  },
  {
    koreanChunks: [
      "나는 (과거에)사용한 적이 없었다",
      "그 소프트웨어를",
      "교육 전에",
    ],
    englishChunks: ["I had never used", "that software", "before the training"],
    fullEnglish: "I had never used that software before the training.",
    additionalExplanation:
      "사용하지 않았다는 것도 과거입니다. 과거에 일어나지 않았다는 것도 하나의 사건입니다. 그래서 이 화자는 지금 사용하지 않았다는 것을 말하려고 합니다. 그냥 인생 통틀어서가 아니라 교육 전까지는 사용 경험이 없다라는 말을 강조하기 위해 had를 붙여 같은 과거도 트레이닝 전의 경험이 없다라는 것을 말한 것입니다.",
  },
  {
    koreanChunks: ["회의는 (과거에)시작되었다", "내가 (과거에)참여했을 때까지"],
    englishChunks: ["The meeting had started", "by the time I joined"],
    fullEnglish: "The meeting had started by the time I joined.",
    additionalExplanation:
      "과거시제가 오지 못한다는 게 아닙니다. 오면 의미가 살짝 달라진다는 거죠, 강조포인트가 달라집니다. 이 화자는 지금 하고 싶은 말이 내가 회의에 참여했을 땐 이미 회의가 시작되어 있었다라는 말이 하고 싶어서 had를 쓴 것입니다. ",
  },
  {
    koreanChunks: ["우리는 (과거에)주문했다", "할인이 (과거에)만료되기 전에"],
    englishChunks: [
      "We had placed",
      "the order",
      "before the discount expired",
    ],
    fullEnglish: "We had placed the order before the discount expired.",
    additionalExplanation:
      "과거시제가 와도 상관없습니다. 그러나 굳이 과거완료를 이 화자가 쓴 이유는 자신이 할인 만료되기 전에 주문을 했다라는, 어떤 게 먼저 일어났는지를 명확히 얘기해주고 싶을 때 사용합니다. 굳이 안 써도 순서를 문맥으로 이해할 수 있지만, 강조를 하거나 격식 표현, 글쓰기에서는 이렇게 과거완료를 사용합니다.",
  },
  {
    koreanChunks: [
      "나는 (과거에)일하는 중이었다",
      "보고서 작업에",
      "매니저가 (과거에)전화했을 때",
    ],
    englishChunks: [
      "I was working",
      "on the report",
      "when the manager called",
    ],
    fullEnglish: "I was working on the report when the manager called.",
    additionalExplanation:
      "과거진행은 쉽습니다. 과거 어떤 시점에 특정 진행 중이던 행동을 말하고 싶을 때 사용합니다. 토익몬에서는 과거진행을 (과거에)~하는 중이었다 라고 해석합니다. ",
  },
  {
    koreanChunks: [
      "그는 (과거에)업데이트하는 중이었다",
      "그의 프로필을",
      "회사 웹사이트에",
    ],
    englishChunks: ["He was updating", "his profile", "on the company website"],
    fullEnglish: "He was updating his profile on the company website.",
    additionalExplanation:
      "토익몬에서는 과거진행을 (과거에)~하는 중이었다 라고 해석합니다. 과거 특정 시점에 진행 중이던 행동을 표현하기 위해 과거진행형(was/were + 동사ing)을 사용했습니다.",
  },
  {
    koreanChunks: [
      "나는 (과거에)기다리는 중이었다.",
      "그의 답장을",
      "회의가 (과거에)시작했을 때",
    ],
    englishChunks: [
      "I had been waiting",
      "for his reply",
      "when the meeting started",
    ],
    fullEnglish: "I had been waiting for his reply when the meeting started.",
    additionalExplanation:
      "토익몬에서는 과거 진행시제와 과거 완료 진행시제를 똑같이 (과거에)~하는 중이었다로 해석합니다. 그럼 화자가 왜 과거완료진행을 썼는지 생각해 보겠습니다. (과거에)기다리는 중이었다라는 것을 말하는 건데 미팅이 시작했을 때 기다리는 중이었다라는 내용보다는 그 시작 전까지 기다리는 중이었음을 말하려고 할 때 사용합니다. 내가 회의 시작할 때까지 계속 기다리고 있는 중이었다라는 부분을 강조하고자 사용합니다.",
  },
  {
    koreanChunks: [
      "직원들은 (과거에)준비하는 중이었다",
      "방을",
      "손님들이 (과거에)도착하기 전에",
    ],
    englishChunks: [
      "The staff had been preparing",
      "the room",
      "before the guests arrived",
    ],
    fullEnglish:
      "The staff had been preparing the room before the guests arrived.",
    additionalExplanation:
      "토익몬에서는 과거완료진행을 (과거에)~하는 중이었다로 해석합니다. 이 문장에서는 손님들이 도착하기 전까지 직원들이 계속해서 방을 준비하고 있었다는 의미를 강조하기 위해 과거완료진행(had been + 동사ing)을 사용했습니다. 이는 손님 도착 이전부터 시작되어 계속 진행되던 준비 작업의 지속성을 나타냅니다. 하고 싶은 말, 더 강조하고 싶은 말이 뭐냐에 따라 원어민들은 시제를 다르게 선택하는 걸 볼 수 있습니다. 그래서 해석이 중요합니다.",
  },
  {
    koreanChunks: [
      "우리는 (미래에) 완료했을 것이다.",
      "프로젝트를",
      "다음 금요일까지",
    ],
    englishChunks: ["We will have completed", "the project", "by next Friday"],
    fullEnglish: "We will have completed the project by next Friday.",
    additionalExplanation:
      "토익몬에서는 미래완료시제를 (미래에) ~ 했을 것이다로 해석합니다. 원어민들은 어떤 일이 미래에 완료되었을 것임을 말할 때 will에 have/has p.p를 붙여 사용합니다.",
  },
  {
    koreanChunks: [
      "그녀는 (미래에) 제출했을 것이다.",
      "최종 보고서를",
      "정오 전에",
    ],
    englishChunks: [
      "She will have submitted",
      "the final report",
      "before noon",
    ],
    fullEnglish: "She will have submitted the final report before noon.",
    additionalExplanation:
      "토익몬에서는 미래완료시제를 (미래에) ~ 했을 것이다로 해석합니다. 이 화자는 지금 정오 전에 제출 완료될 예정임을 설명하고 싶어합니다.",
  },
  {
    koreanChunks: [
      "팀은 (미래에) 검토했을 것이다.",
      "모든 지원서를",
      "하루가 끝날 때까지",
    ],
    englishChunks: [
      "The team will have reviewed",
      "all applications",
      "by the end of the day",
    ],
    fullEnglish:
      "The team will have reviewed all applications by the end of the day.",
    additionalExplanation:
      "토익몬에서는 미래완료시제를 (미래에) ~ 했을 것이다로 해석합니다. 이 문장은 하루가 끝날 때까지 팀이 모든 지원서 검토를 완료할 것이라는 의미를 전달합니다. 미래의 특정 시점(하루의 끝)까지 어떤 일이 완료될 것임을 나타낼 때 미래완료시제(will have + 과거분사)를 사용합니다.",
  },
  {
    koreanChunks: ["서류들은 (미래에) 서명되었을 것이다.", "회의 전에"],
    englishChunks: [
      "The documents will have been signed",
      "before the meeting",
    ],
    fullEnglish: "The documents will have been signed before the meeting.",
    additionalExplanation:
      "토익몬에서는 미래완료시제를 (미래에) ~ 했을 것이다로 해석합니다. 이 문장은 회의가 시작되기 전에 서류에 서명이 완료될 것이라는 의미를 전달합니다. 미래의 특정 시점(회의 시작) 이전에 어떤 일이 완료될 것임을 나타낼 때 미래완료시제(will have + 과거분사)를 사용합니다. 이 문장은 수동태(passive voice)와 함께 사용되어 'will have been + 과거분사' 형태로 나타납니다.",
  },
  {
    koreanChunks: [
      "나는 (미래에) 참석할 것이다",
      "컨퍼런스에",
      "다음 금요일에",
    ],
    englishChunks: ["I will be attending", "a conference", "next Friday"],
    fullEnglish: "I will be attending a conference next Friday.",
    additionalExplanation:
      "토익몬에서는 미래진행시제를 (미래에) ~하는 중일 것이다로 해석합니다. 화자는 다음 주 금요일엔 회의에 참석중일 예정임을 말하려고 미래진행시제를 사용했습니다. ",
  },
  {
    koreanChunks: ["그녀는 (미래에) 일하는 중일 것이다", "집에서", "내일"],
    englishChunks: ["She will be working", "from home", "tomorrow"],
    fullEnglish: "She will be working from home tomorrow.",
    additionalExplanation:
      "토익몬에서는 미래진행시제를 (미래에) ~하는 중일 것이다로 해석합니다. 이 화자는 내일은 그녀가 재택근무 중일 것이라는 말을 하려고 합니다. 미래의 특정 시점(내일)에 진행 중일 행동을 표현할 때 미래진행시제(will be + 동명사)를 사용합니다.",
  },
  {
    koreanChunks: [
      "다음 달까지, ",
      "그녀는 (미래에) 일하는 중이었을 것이다",
      "여기서",
      "5년 동안",
    ],
    englishChunks: [
      "By next month,",
      "she will have been working",
      "here",
      "for five years",
    ],
    fullEnglish:
      "By next month, she will have been working here for five years.",
    additionalExplanation:
      "토익몬에서는 미래완료진행시제를 (미래에)~하는 중이었을 것이다로 해석합니다. 이 화자는 그녀가 다음 달이면 5년 동안 일하는 중이었을 것이다 즉 5년 근속이 되는 것을 말하려고 합니다.",
  },
  {
    koreanChunks: [
      "그들은 (미래에) 사용하는 중이었을 것이다",
      "새로운 시스템을",
      "1년 동안",
      "12월까지",
    ],
    englishChunks: [
      "They will have been using",
      "the new system",
      "for a full year",
      "by December",
    ],
    fullEnglish:
      "They will have been using the new system for a full year by December.",
    additionalExplanation:
      "토익몬에서는 미래완료진행시제를 (미래에)~하는 중이었을 것이다로 해석합니다. 이 문장은 12월이 되면 그들이 새로운 시스템을 1년 동안 사용해오고 있을 것이라는 의미를 전달합니다. 미래의 특정 시점(12월)까지 계속 진행되어 온 행동을 표현할 때 미래완료진행시제(will have been + 동명사)를 사용합니다.",
  },
];
